import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { FormField } from "@faire/retailer-visitor-shared/components/SignUpForm/FormField";
import { isFaireEmail, isInvalidEmail } from "@faire/retailer-visitor-shared/components/SignUpForm/validate";
import { isValidEmail } from "@faire/retailer-visitor-shared/lib/validation";
import { useSettingFaireDirectSignupEmailAutofill } from "@faire/retailer-visitor-shared/settings/useSettingFaireDirectSignupEmailAutofill";
import { getWebApiErrorMessage } from "@faire/web--source/common/getErrorMessage";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { useQueryParams } from "@faire/web--source/ui/hooks/useQueryParams";
import { useRefFrom } from "@faire/web--source/ui/hooks/useRefFrom";
import checkUserAvailability from "@faire/web-api--source/api/user/availability/post";
import { ICheckEmailAddressAndBusinessAvailabilityRequest } from "@faire/web-api--source/indigofair/data/ICheckEmailAddressAndBusinessAvailabilityRequest";
import { QueryParameters as SignUpQueryParameters } from "@faire/web-api--source/routes/www/welcome/r/personal";
import { useCallback } from "react";
var EVENT_NAME = "email";
var EVENT_PREFIX = "sign-up-page/modal";
export var useEmailState = function(isFaireDirectSignup) {
    var signUpParams = useQueryParams(SignUpQueryParameters.parse);
    var settingFaireDirectSignupEmailAutofill = useSettingFaireDirectSignupEmailAutofill();
    var strictLocalize = useStrictLocalization().strictLocalize;
    var emailFromSignupParams = !!signUpParams.email && isValidEmail(signUpParams.email) ? signUpParams.email : "";
    var initialValue = !isFaireDirectSignup || settingFaireDirectSignupEmailAutofill ? emailFromSignupParams : "";
    var email = useRefFrom(function() {
        return new FormField(initialValue, EVENT_NAME, isInvalidEmail, EVENT_PREFIX);
    }).current;
    var setEmailValidationErrors = useCallback(function() {
        if (email.isInvalid) {
            var emailError = strictLocalize({
                id: "VuaRRj",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Please enter a valid email address"
                    }
                ]
            });
            email.setError(emailError);
            return true;
        }
        return false;
    }, [
        email,
        strictLocalize
    ]);
    var setSomethingWentWrongEmailError = useCallback(function(error) {
        var defaultMessage = strictLocalize({
            id: "xyk3SP",
            defaultMessage: [
                {
                    type: 0,
                    value: "Something went wrong. Please try again later."
                }
            ]
        });
        email.setError(getWebApiErrorMessage(error, strictLocalize, defaultMessage));
    }, [
        email,
        strictLocalize
    ]);
    var getIsEmailAvailable = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var trimmedEmailAddress, email_address_available, emailError;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    trimmedEmailAddress = email.value.trim();
                    return [
                        4,
                        checkUserAvailability(ICheckEmailAddressAndBusinessAvailabilityRequest.build({
                            email_address: trimmedEmailAddress
                        }))
                    ];
                case 1:
                    email_address_available = _state.sent().email_address_available;
                    if (email_address_available) {
                        if (isFaireEmail(email.value)) {
                            emailError = strictLocalize({
                                id: "gh24zC",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Use your Faire email address with a + segment (e.g. your.email+test@faire.com)"
                                    }
                                ]
                            });
                            email.setError(emailError);
                            return [
                                2,
                                false
                            ];
                        }
                        return [
                            2,
                            true
                        ];
                    }
                    return [
                        2,
                        false
                    ];
            }
        });
    }), [
        email,
        strictLocalize
    ]);
    return {
        email: email,
        getIsEmailAvailable: getIsEmailAvailable,
        setEmailValidationErrors: setEmailValidationErrors,
        setSomethingWentWrongEmailError: setSomethingWentWrongEmailError
    };
};
